import styled from 'styled-components'

const VietnameseText = styled.span`
  font-family: 'Roboto', sans-serif;
`

export { VietnameseText }
